import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Screen from "./Screen";
import Keypad from "./Keypad";
import useDataRequesting from "../../../hooks/useDataRequesting";
import { getFlatObject } from "../../../../helper/helper";
import Alert from "../../../component/Alert";
import NotificationModal from "./NotificationModal";
import usePuskesmas from "view/hooks/usePuskesmas";
import moment from "moment";
import { set } from "date-fns";

const PatientPage = (props) => {
  const [patientId, setPatientId] = useState("");
  const [data, setData] = useState(null);
  const [isNotificationShow, setIsNotificationShow] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [rm, setRm] = useState(false);

  const { results, loading, error, setRequest } = useDataRequesting();
  const {
    results: resultsPcare,
    loading: loadingPcare,
    setRequest: setPcare,
  } = useDataRequesting();

  const {
    results: resultsIhs,
    loading: loadingIhs,
    setRequest: setIhs,
  } = useDataRequesting();

  // useEffect(() => {
  //   setData('');
  // }, [ isNotificationShow ]);

  useEffect(() => {
    setIsUpdate(true);
    if (results) {
      setData(results.data);
      setPatientId("");
    }
    setIsUpdate(false);
  }, [results]);

  useEffect(() => {
    if (resultsIhs) {
      setData({
        ...data,
        id_ihs: resultsIhs.data?.entry?.length
          ? resultsIhs.data.entry[0].resource.identifier[0].value
          : data.id_ihs,
      });
    }
  }, [resultsIhs]);

  useEffect(() => {
    if (data) {
      setIsUpdate(!isUpdate);
    }
  }, [data]);

  useEffect(() => {
    console.log(isUpdate, resultsPcare.response, results);
    if (isUpdate) {
      if (!resultsPcare.response && results) {
        setPcare({
          url: `/pcare/peserta/${
            results.data.visits
              ? results.data.visits.insurance_no.length > 0
                ? results.data.visits.insurance_no
                : 0
              : 0
          }`,
          method: "get",
        });
      }

      if (data) {
        if (data.id_ihs == null || data.id_ihs == undefined) {
          setIhs({
            url: `fhir/patient/nik/${results.data.nik ? results.data.nik : 0}`,
            method: "get",
          });
        }
      }
    }
  }, [isUpdate]);

  useEffect(() => {
    if (!resultsPcare) return;
    if (resultsPcare.response) {
      if (
        resultsPcare.response.aktif &&
        props.puskesmas.code_provider ===
          resultsPcare.response.kdProviderPst.kdProvider
      ) {
        setData((prevState) => {
          return {
            ...prevState,
            status_kepesertaan: resultsPcare.response.ketAktif || "-",
            visits: {
              ...prevState.visits,
              payment_type_id:
                prevState.visits.payment_type_id === 1
                  ? 7
                  : prevState.visits.payment_type_id,
              pcare_patient_code_provider: resultsPcare.response.kdProviderPst
                ? resultsPcare.response.kdProviderPst.kdProvider
                : "",
              pcare_treatment_code: "10",
              pcare_sick: true,
              visit_type:
                moment(new Date()).format("YYYY") ===
                moment(prevState.visits.created_at).format("YYYY")
                  ? "1"
                  : "2",
            },
          };
        });
      } else {
        setIsNotificationShow(true);
        setData((prevState) => {
          return { ...prevState };
        });
      }
    } else {
      setIsNotificationShow(true);
      setData((prevState) => {
        return { ...prevState };
      });
    }
  }, [resultsPcare]);

  if (error) {
    Alert("error", error.statusText);
  }

  return (
    <div className="container mt--2">
      <NotificationModal
        show={isNotificationShow}
        setModalShow={setIsNotificationShow}
        data={getFlatObject(data)}
      />
      <div className="row mb-5">
        <div className="col offset-9">
          <Link to="/apm">
            <button
              type="button"
              className="btn btn-warning btn-icon float-right"
            >
              <span className="btn-inner--icon">
                <i className="fas fa-arrow-left"></i>
              </span>
              <span className="btn-inner--text">KEMBALI</span>
            </button>
          </Link>
        </div>
        <label className="custom-toggle custom-toggle-success">
          <input
            type="checkbox"
            checked={rm}
            onChange={(e) => setRm(e.target.checked)}
          />
          <span
            className="custom-toggle-slider rounded-circle"
            data-label-off="No RM"
            data-label-on="No Rm"
          />
        </label>
      </div>
      <div className="row">
        <div className="col-7 mt--4 mr-3">
          <Screen
            data={getFlatObject(data) || {}}
            loading={loading}
            loadingPcare={loadingPcare}
            resultsPcare={resultsPcare}
          />
        </div>
        <div className="col-4">
          <Keypad
            loading={loading || loadingPcare}
            text={patientId}
            click={setPatientId}
            submit={() =>
              rm
                ? setRequest({
                    url: `/management/patients/search/rm/${patientId}`,
                    method: "get",
                  })
                : setRequest({
                    url: `/management/patients/search/${patientId}`,
                    method: "get",
                  })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default usePuskesmas(PatientPage);
